import { render, staticRenderFns } from "./ProjectsManagerPage.vue?vue&type=template&id=465ec3b9"
import script from "./ProjectsManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports